const MinusIcon: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      width="16"
      height="2"
      viewBox="0 0 26 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1 1H25" stroke="black" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export default MinusIcon;
